import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";

type TinyMCEEditor = any;

interface Props {
  formData: {
    job_description: string;
  };
  formError: {
    job_description?: string;
  };
  handleBlur: (
    e: React.FocusEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => void;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  setFormError: React.Dispatch<React.SetStateAction<any>>;
}

const JobDescriptionField: React.FC<Props> = ({
  formData,
  formError,
  setFormData,
  setFormError,
}) => {
  const editorRef = useRef<TinyMCEEditor | null>(null);

  // Handle content change (update value + clear error if non-empty)
  const handleEditorChange = (content: string) => {
    setFormData((prev: any) => ({
      ...prev,
      job_description: content,
    }));

    setFormError((prev: any) => ({
      ...prev,
      job_description: content.trim() !== "" ? "" : prev.job_description,
    }));
  };

  return (
    <div className="mb-3">
      <label className="form-label">
        Job Description <span className="text-danger">*</span>
      </label>

      <Editor
        apiKey="bzfndv9djnqx04vladwhm4t6bt9vz89bmiv4fvxqzk0u3k45"
        onInit={(_evt, editor) => (editorRef.current = editor)}
        value={formData.job_description}
        init={{
          height: 300,
          menubar: false,
          plugins: [
            "lists",
            "advlist",
            "autolink",
            "link",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "table",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | formatselect | bold italic underline | " +
            "alignleft aligncenter alignright alignjustify | " +
            "bullist numlist outdent indent | removeformat | help",
          branding: false,
          toolbar_mode: "wrap",
        }}
        onEditorChange={handleEditorChange}
      />

      {formError.job_description && (
        <small className="text-danger">{formError.job_description}</small>
      )}
    </div>
  );
};

export default JobDescriptionField;
